import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">





          {/* Outdated call-for-special-session announcement hidden, keep content for future reuse.
          <div className="call-sp">
            <h2>ICSI 2026 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              ICSI 2026 technical program will include special sessions. Their aim
              is to provide a complementary flavor to the regular sessions and
              should include hot topics of interest to the swarm intelligence
              community that may also go beyond disciplines traditionally
              represented at ICSI.
            </p>
            <p align="justify">
              <b>
                Prospective organizers of special sessions should submit proposals indicating:
              </b>
            </p>
            <p align="left">
              <ul>
                <li>
                  Title of the session.
                </li>
                <li>
                  Rationale of the need for the special session at ICSI.
                  <br></br>
                  The rationale should stress the novelty of the topic and/or its multidisciplinary flavor, and must explain how it is different  from the subjects covered by the regular sessions.
                </li>
                <li>
                  Short biography of the organizers.
                </li>
                <li>
                  List of 5 – 6 contributed papers (including titles, authors,
                  contact information of the corresponding author){" "}
                  (this can also be provided later when they become available).
                </li>
              </ul>

              <br />
            </p>

            <p>
              <b>
                <a href="./files/ICSI2026_Special_Session_Proposals_Template.docx" download="ICSI2026_Special_Session_Proposals_Template.docx">Click here to download the ICSI&apos;2026 Special Session proposals template.</a>
              </b>
            </p>
            <p align="justify">
              Proposals are due on or before 	February 20th, 2026 and should be sent
              via e-mail (in either pdf or plain ASCII text form) to the special
              sessions chair (to be announced) and forward to ICSI 2026
              secretariat at
              <a href="mailto:icsi2026@iasei.org">icsi2026@iasei.org</a>.
            </p>
            <p align="justify">
              Proposals will be evaluated based on the timeliness of the topic,
              the qualifications of the organizers and the authors of the papers
              proposed in the session. In its decision, the committee will try to
              realize a balance of the topics across the technical areas
              represented in swarm intelligence.
            </p>
            <p align="justify">
              Notification of acceptance will be sent to the organizers no later
              than January 31, 2026. Authors of papers included in approved
              special sessions should submit their manuscript on or before January
              30, 2026. Manuscripts should conform to the formatting and
              electronic submission guidelines of regular ICSI papers (Springer’s
              LNCS format)这里26年删除了.
            </p> *
            <p>
              When they submit papers, there is a choice to indicate that their
              papers are special session papers which will also undergo peer
              review. It is the responsibility of the organizers to ensure that
              their special session meets the ICSI quality standards. If, at the
              end of the review process, less than four papers are accepted, the
              session will be canceled and the accepted papers will be moved to
              regular sessions.
            </p>
          </div>
          */}

          <br /><br />
          <hr></hr>
          <br /><br />



          {/* begin special session 1 */}




          <h3 id="session1">
            Special Session 1: &quot;Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Large Language Models (LLMs) represent a significant leap in AI, capable of understanding context, generating coherent text, and performing various language tasks with impressive accuracy. These models have been trained on extensive datasets and can mimic human-like language understanding and generation. Despite their advanced capabilities, LLMs face challenges in areas like computational efficiency, adaptability to new and evolving data, and depth of context understanding. <br></br>

            Swarm Intelligence Optimization Algorithms, drawing inspiration from natural phenomena such as the collective behavior of bird flocks or ant colonies, offer a unique approach to problem-solving. Algorithms like Particle Swarm Optimization (PSO) and Fireworks Algorithm (FWA) exemplify this approach, known for efficiently navigating complex, multi-dimensional search spaces. These algorithms excel in optimizing non-linear and intricate functions, which is instrumental in enhancing decision-making and problem-solving aspects of various computational tasks.
            <br></br>
            In this special session, we will explore how the advanced data processing and pattern recognition capabilities of LLMs can contribute to the evolution of swarm intelligence algorithms. Discussions will revolve around novel approaches for applying LLMs to improve the design, implementation, and effectiveness of swarm intelligence methods. Topics will include leveraging LLMs for better algorithmic strategies, enhancing decision-making processes in swarm algorithms, and exploring the adaptability and scalability of these algorithms in diverse applications.
            <br></br>

            By bridging the gap between LLMs and swarm intelligence, this session aims to foster innovative research and collaboration, paving the way for significant advancements in both fields. We anticipate that this interdisciplinary approach will not only enhance our understanding of swarm intelligence algorithms but also expand the potential applications of LLMs in various AI-driven solutions.

            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li> <b>Enhancing Swarm Intelligence Algorithms with LLMs</b>: Exploring how large language models can contribute to the design and refinement of swarm intelligence algorithms.</li>
              <li> <b>Data Processing and Analysis in Swarm Intelligence</b>: Leveraging LLMs for advanced data processing, pattern recognition, and analysis in swarm intelligence systems.</li>
              <li> <b>Algorithmic Strategy and Decision Making</b>: Utilizing LLMs to improve decision-making processes and strategic planning in swarm intelligence optimization.</li>
              <li> <b>Adaptability and Dynamic Learning</b>: Investigating the role of LLMs in enhancing the adaptability and learning mechanisms of swarm intelligence algorithms in dynamic environments.</li>
              <li> <b>Scalability of Swarm Algorithms</b>: Exploring how LLMs can aid in scaling swarm intelligence algorithms for large-scale and complex problem-solving scenarios.</li>
              <li> <b>Cross-Domain Applications</b>: Discussing the application of LLM-enhanced swarm intelligence algorithms in various fields such as robotics, logistics, environmental modeling, and healthcare.</li>
              <li> <b>Model evaluation</b>: Analyzing the performance of LLM-enhanced swarm intelligence algorithms against traditional methods.</li>
              <li> <b>Integration Challenges and Solutions</b>: Addressing the technical and conceptual challenges in integrating LLMs with swarm intelligence optimization algorithms.</li>

            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2026 instruction for authors and submit your
            paper via the ICSI 2026 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS1 &quot; -- the Special Session on Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Shipeng Cen</td>
                <td>Peking University</td>
                <td>censhipeng@pku.edu.cn</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>




          {/* --------------------------------------------------------------------------------------- */}
          <h3 id="session2">
            Special Session2: &quot;Collaborative Swarm Intelligence and Swarm Robotics: Theories, Algorithms, and Applications&quot;
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            The coordination of large-scale multi-agent systems, particularly in the realm of swarm robotics, has emerged as a transformative field in computational intelligence and robotics. Inspired by the collective behaviors observed in biological systems, Collaborative Swarm Intelligence focuses on designing algorithms that enable decentralized, self-organized, and robust cooperation among individual agents. As hardware capabilities improve and AI algorithms evolve, the gap between theoretical swarm models and physical swarm robotics is narrowing. This special session aims to bring together researchers to discuss recent advances in cooperative behaviors, distributed control strategies, and the real-world deployment of robot swarms. It will provide a forum for exploring how local interactions lead to global intelligence, addressing challenges in scalability, flexibility, and human-swarm interaction.
            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following topics:
            <ul>
              <li>Foundations of collaborative swarm intelligence: Distributed control, self-organization mechanisms, and collective decision-making processes;</li>
              <li>Swarm robotics coordination: Formation control, flocking, path planning, and task allocation in dynamic environments;</li>
              <li>Machine learning for swarms: Multi-agent reinforcement learning (MARL), evolutionary robotics, and transfer learning from simulation to reality (Sim2Real);</li>
              <li>Heterogeneous swarm systems: Collaboration between different types of robots (e.g., UAV-UGV coordination) and cross-domain cooperation;</li>
              <li>Human-Swarm Interaction (HSI): Interfaces, control strategies, and trust modeling for human operators managing large-scale swarms;</li>
              <li>Resilience and fault tolerance: Strategies for maintaining swarm performance in the presence of agent failures or communication disruptions;</li>
              <li>Real-world applications: Search and rescue, precision agriculture, environmental monitoring, warehouse logistics, and construction automation.</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2026 instruction for authors and submit your
            paper via the ICSI 2026 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS 2 &quot; -- Collaborative Swarm Intelligence and Swarm Robotics
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Jiali Chen</td>
                <td>Peking University</td>
                <td>jialichen@pku.edu.cn</td>
              </tr>

            </table>
          </p>


          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>


          {/* ------------------------------------------------------------------------------------------------------ */}


          <h3 id="session3">
            Special Session3: &quot;Diversity Enhancement in Evolutionary Algorithms: Mechanisms, Methods and Applications&quot;
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Population diversity stands as one of the most fundamental yet challenging aspects of evolutionary algorithms (EAs), critically influencing their ability to balance exploration and exploitation, avoid premature convergence, and ultimately determine solution quality across a wide spectrum of optimization problems. The importance of diversity preservation cannot be overstated—it enables global exploration to discover multiple optima, enhances the effectiveness of crossover operators, facilitates adaptation in dynamic environments, and supports the search for complete Pareto fronts in multi-objective optimization. This special session addresses the timely and increasingly important challenge of enhancing and maintaining population diversity in evolutionary computation, exploring recent advances such as quality-diversity algorithms, sophisticated niching strategies, and adaptive diversity control mechanisms.
            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following topics:
            <ul>
              <li>Diversity Mechanisms and Techniques: Niching methods, crowding mechanisms, archive-based preservation, and adaptive diversity control;</li>
              <li>Multimodal Optimization: Algorithms for locating multiple global/local optima and decision space diversity;</li>
              <li>Quality-Diversity Algorithms: MAP-Elites, novelty search, illumination algorithms, and their applications;</li>
              <li>Diversity in Different EA Paradigms: Mechanisms for genetic algorithms, differential evolution, particle swarm optimization, and genetic programming;</li>
              <li>Application Domains: Neural architecture search, protein structure prediction, engineering design, and robotics;</li>
              <li>Emerging Topics: Diversity-driven automated algorithm configuration and transfer learning in multi-tasking.</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2026 instruction for authors and submit your
            paper via the ICSI 2026 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS3 &quot; -- Diversity Enhancement in Evolutionary Algorithms: Mechanisms, Methods and Applications
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Wenhua Li</td>
                <td>National University of Defense Technology</td>
                <td>liwenhua1030@aliyun.com</td>
              </tr>
              <tr>
                <td>Rui Wang</td>
                <td>National University of Defense Technology</td>
                <td>ruiwangnudt@gmail.com</td>
              </tr>
            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>



          {/* ------------------------------------------------------------------------------------------------------ */}


          <h3 id="session4">
            Special Session4: &quot;Enhancing Exploratory Adaptability and Robustness in Swarm Intelligence Algorithms and Applications&quot;
            <p align="center">&nbsp;</p>
          </h3>

          <p>
            Swarm Intelligence (SI) algorithms have achieved notable success in solving complex optimization problems due to their population-based and gradient-free characteristics. However, many conventional SI methods rely on fixed search behaviors or static parameter settings, which often leads to premature convergence, stagnation in local optima, and unstable performance when facing large-scale, noisy, or dynamically changing optimization environments. Improving adaptability across different search stages and enhancing robustness across diverse problem characteristics has therefore become a critical challenge in contemporary swarm intelligence research.
            <br></br>
            This special session aims to provide a focused forum for recent advances in adaptive and robust swarm intelligence algorithms. It encourages contributions that introduce mechanisms enabling swarm systems to dynamically regulate exploration and exploitation, preserve population diversity, and respond effectively to varying optimization landscapes. Both methodological developments and real-world applications of adaptive swarm intelligence are welcome, with the goal of promoting more reliable and widely applicable swarm optimization frameworks.
          </p>

          <br></br>

          <p>
            <h3>Topics of Interest</h3>
          </p>

          <p>
            Research areas include, but are not limited to, the following topics:
            <ul>
              <li>Adaptive and self-evolving swarm intelligence algorithms</li>
              <li>Exploration–exploitation balancing strategies in SI</li>
              <li>Robust swarm optimization under noisy, dynamic, or high-dimensional environments</li>
              <li>Fitness–distance balance and diversity preservation mechanisms</li>
              <li>Multi-population and cooperative swarm frameworks</li>
              <li>Hyper-heuristic and learning-assisted swarm intelligence</li>
              <li>Hybrid SI models integrating evolutionary computation and machine learning</li>
              <li>Theoretical analysis of adaptability and robustness in SI</li>
              <li>Large-scale and complex optimization using adaptive SI</li>
              <li>Real-world applications in energy, healthcare, materials science, robotics, and smart manufacturing</li>
              <li>Benchmarking and evaluation of robust swarm intelligence algorithms</li>
            </ul>
          </p>

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2026 instruction for authors and submit your paper via the ICSI 2026 online submission system. Please specify that your paper is for &nbsp;
            <strong>
              &quot;SS4 &quot; -- Enhancing Exploratory Adaptability and Robustness in Swarm Intelligence Algorithms
            </strong>{" "}
            in your paper.
          </p>

          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Yang Cao</td>
                <td>Hokkaido University</td>
                <td>yang.cao.y4@elms.hokudai.ac.jp</td>
              </tr>
              <tr>
                <td>Jun Yu</td>
                <td>Niigata University</td>
                <td>yujun@ie.niigata-u.ac.jp</td>
              </tr>
              <tr>
                <td>Yuefeng Xu</td>
                <td>Niigata University</td>
                <td>f25l005c@mail.cc.niigata-u.ac.jp</td>
              </tr>
              <tr>
                <td>Rui Zhong</td>
                <td>Hokkaido University</td>
                <td>zhongrui@iic.hokudai.ac.jp</td>
              </tr>
            </table>
          </p>



          {/* ------------------------------------------------------------------------------------------------------ */}


          <p align="center">&nbsp;</p>
          <hr></hr>
          <p align="center">&nbsp;</p>
          <br></br>


          <h3 id="session5">
            Special Session 5: &quot;Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem&quot;
            <p align="center">&nbsp;</p>
          </h3>

          <p>
            Addressing highly complex combinatorial optimization problems with multiple objectives and various real-world constraints, which are intractable to exact methods, presents to be one of current research challenges in evolutionary computation. With the rapid development of computation power and artificial intelligence, machine learning and swarm intelligence have become promising tools. Machine learning algorithms, such as the reinforcement learning algorithms, have shown strong ability in interactive learning environment. Swarm intelligence algorithms, inspired by the behavior in self-organized groups, such as birds, ants, bacteria, etc., hold the superiority in solving complex optimization problems. In recent years, the breakthroughs of large language models (LLMs) have brought new opportunities to this field. Their strong capabilities in representation learning, reasoning, code generation, and knowledge transfer provide novel ideas for automating and enhancing the design of evolutionary algorithms, which can be further integrated with machine learning and swarm intelligence to tackle combinatorial optimization problems. How to utilize swarm intelligence algorithms, general machine learning algorithms, and LLMs as a specific machine learning method to deal with combinatorial optimization problem remains to be an interesting topic and has attracted attentions from both researchers and engineers.
            <br></br>
            The objective of this special session is to gather recent theoretical contributions in machine learning and swarm intelligence fields, particularly the theoretical advances and methodological innovations of LLM-assisted evolutionary algorithm design. It also collects unpublished methods for practical combinatorial optimization problems, and aims to discuss emerging challenges and future research directions in this interdisciplinary domain.
          </p>

          <br></br>

          <p>
            <h3>Topics of Interest</h3>
          </p>

          <p>
            Research areas include, but are not limited to, the following topics:
            <ul>
              <li>Theoretical contributions in machine learning algorithms: reinforcement learning, deep learning, meta-learning, etc.</li>
              <li>Theoretical foundations and analysis of large language models (LLM) for evolutionary algorithm design and optimization (as a specific machine learning sub-direction).</li>
              <li>Unpublished ideas in swarm intelligence algorithms: particle swarm optimization, genetic algorithm, etc.</li>
              <li>LLM-assisted evolutionary algorithm components, including representation design, variation operators, fitness modeling, and parameter control.</li>
              <li>Original work towards multi-objective problems, multi-task problems and constrained problems.</li>
              <li>Applications of LLM-assisted evolutionary algorithms to real-world optimization problems, such as scheduling, routing, engineering design, and multi-objective optimization.</li>
              <li>Benchmarking, evaluation methodologies, and robustness analysis for LLM-assisted evolutionary algorithms.</li>
              <li>Other intelligent computing and swarm intelligence related algorithms and applications.</li>
            </ul>
          </p>

          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2026 instruction for authors and submit your paper via the ICSI 2026 online submission system. Please specify that your paper is for &nbsp;
            <strong>
              &quot;SS5 &quot; -- Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem
            </strong>{" "}
            in your paper.
          </p>

          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Wenjie Yi</td>
                <td>Shenzhen University</td>
                <td>wenjie.yi@szu.edu.cn</td>
              </tr>
            </table>
          </p>










        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
